export default __webpack_public_path__ + "static/aerodyne-622186008733d20dbec9e9d6c59ce2d6.png";